var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dataReady)?_c('div',[_c('Dashboard',{attrs:{"learn-paths":_vm.learnPaths}})],1):_c('div',[_c('ContentSpinner')],1)}
var staticRenderFns = []

export { render, staticRenderFns }